const secrets = {
  api: {
    baseUri: process.env.REACT_APP_BASE_URI,
    jwtAud: 'fbo',
  },
  pti: {
    token: process.env.REACT_APP_PTI_TOKEN,
    issueUrl: 'https://preflighttech.com/api/1/issues'
  },
  app: {
    name: 'fbo-portal',
    version: 20220322,
  }
};

export default secrets;
